// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner-module__spinner","isSmall":"Spinner-module__isSmall","isMedium":"Spinner-module__isMedium","isLarge":"Spinner-module__isLarge"};